<!--
 * @Description: 查询需求
 * @Author: PF
 * @Date: 2023-12-19 10:06:10
 * @LastEditors: PF
 * @LastEditTime: 2026-10-13 14:41:40
-->
<template>
  <div class="list-page hp100">
    <el-container class="hp100">
      <el-header class="list-head">
        <!-- 搜索区域 BEGIN -->
        <div class="mb10" style="display: flex;align-items: center;">
          <el-input
            v-model="dataGrid.parms.bt"
            class="w220 mr8"
            placeholder="标题关键字"
            clearable
            :prefix-icon="Search"
            @clear="bindTable()"
            @keyup.enter="bindTable()"
          />
          <el-select v-model="dataGrid.parms.lx" class="w150 mr8" placeholder="需求类型" clearable filterable @change="bindTable()">
            <el-option v-for="item in xqlxData.list" :key="item.value" :label="item.name" :value="item.value" />
          </el-select>
          <span class="mr8">解决状态</span>
          <el-radio-group v-model="dataGrid.parms.jjzt" class="mr8" @change="bindTable()">
            <el-radio v-for="item in jjztData.list" :key="item.value" :value="item.value">{{ item.name }}</el-radio>
          </el-radio-group>
          <el-link type="primary" :underline="false" class="mr8" @click="resetSearch()">
            <el-icon class="mr2"><RefreshLeft /></el-icon>查看全部
          </el-link>
          <el-button type="warning" :icon="Delete" :disabled="!dataGrid.multipleSelection.length" @click="remove()">
            批量删除<span v-if="dataGrid.multipleSelection.length">({{ dataGrid.multipleSelection.length }})</span>
          </el-button>
        </div>
        <!-- 搜索区域 END -->

      </el-header>

      <el-main class="list-body">
        <el-table
          :data="dataGrid.data"
          :default-sort="dataGrid.orderBy"
          v-loading="dataGrid.loading"
          empty-text="暂无需求数据"
          height="100%"
          border
          stripe
          highlight-current-row
          @sort-change="dataGrid.sortChange"
          @selection-change="dataGrid.selectionChange"
        >
          <!-- 冻结列-Left BEGIN -->
          <el-table-column type="selection" width="55" align="center" />
          <el-table-column label="序号" type="index" :index="indexMethod" width="60" fixed align="center" />
          <!-- 冻结列-Left END -->
          <el-table-column label="标题" prop="bt" min-width="250" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']">
            <template #default="scope">
              <span class="link-title" @click="openDetail = true; row = scope.row">{{ scope.row.bt }}</span>
            </template>
          </el-table-column>
          <el-table-column label="所属菜单" min-width="250" align="center" show-overflow-tooltip>
            <template #default="scope">
              <span v-if="scope.row.sscdlj">{{ scope.row.sscdlj + '-' + scope.row.menuMc }}</span>
              <span v-else-if="scope.row.xtmc && !scope.row.menuMc">{{ scope.row.xtmc }}-首页</span>
              <span v-else-if="!scope.row.xtmc && !scope.row.menuMc">首页</span>
            </template>
          </el-table-column>
          <el-table-column label="类型" prop="lx.name" width="90" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']">
            <template #default="scope">
              <el-tag v-if="scope.row.lx && scope.row.lx.name" size="small" effect="plain">{{ scope.row.lx.name }}</el-tag>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column label="提出人" prop="tcr" width="100" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
          <el-table-column label="提出时间" prop="tcsj" width="150" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
          <el-table-column label="解决人" prop="jjr" width="120" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']">
            <template #default="scope">
              <span>{{ scope.row.jjr || '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="解决时间" prop="jjsj" width="150" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']">
            <template #default="scope">
              <span>{{ scope.row.jjsj || '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="解决状态" prop="jjzt.name" width="110" align="center" show-overflow-tooltip>
            <template #default="scope">
              <el-tag v-if="scope.row.jjzt" size="small" :type="statusType(scope.row.jjzt.value)" effect="light">
                {{ scope.row.jjzt.name }}
              </el-tag>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <!-- 冻结列-Right BEGIN -->
          <el-table-column label="操作" width="140" fixed="right" align="center">
            <template #default="scope">
              <el-button link type="primary" v-if="scope.row.jjzt && scope.row.jjzt.value === 0" @click="toFenPei(scope.row)">分配</el-button>
              <el-button link type="primary" v-if="scope.row.jjzt && scope.row.jjzt.value === unsolvedValue" @click="toKaiShi(scope.row)">开始</el-button>
              <el-button link type="primary" v-if="scope.row.jjzt && scope.row.jjzt.value === 2" @click="toJieJue(scope.row)">解决</el-button>
              <el-button link type="primary" @click="openEdit = true; row = scope.row">修改</el-button>
              <el-button link type="warning" @click="dataGrid.multipleSelection = [scope.row.id]; remove()">删除</el-button>
            </template>
          </el-table-column>
          <!-- 冻结列-Right END -->
        </el-table>
      </el-main>
      <el-footer>
        <pagination :pagination="dataGrid.pagination" @ReturnData="bindTable" />
      </el-footer>
    </el-container>
  </div>

  <edit v-if="openEdit" v-model:openEdit="openEdit" :row="row" @ReturnData="bindTable" />
  <detail v-if="openDetail" v-model:openDetail="openDetail" :row="row" />
</template>

<script setup>
import { ref, computed, watch } from 'vue'
import {
  loadList,
  loadSelect,
  actionPost,
  actionPatch,
  submitDataGridAction
} from '@/api/common.js'
import { getDate } from '@/utils/index.js'
import {
  successPrompt,
  warningPrompt,
  errorPrompt
} from '@/utils/promptInfo.js'
import { Search, RefreshLeft, Delete } from '@element-plus/icons-vue'
import pagination from '@/components/pagination.vue'
import { ElMessageBox } from 'element-plus'
import edit from './edit.vue'
import detail from './detail.vue'

const props = defineProps({
  indRow: { type: Object, required: false }
})

// 需求类型
const xqlxData = ref({ list: [] })
loadSelect({ url: '/api/v2/sys/xuqiu/xuqiuleixing', data: xqlxData })
// 解决状态
const jjztData = ref({ list: [] })
loadSelect({ url: '/api/v2/sys/xuqiu/jiejuezhuangtai', data: jjztData })
// “未解决”对应的字典值（loadSelect 异步填充 wjj，取不到时兜底为 1）
const unsolvedValue = computed(() => (jjztData.value.wjj === undefined ? 1 : jjztData.value.wjj))

const DEFAULT_PARMS = () => ({ bt: '', lx: '', jjzt: 0 })

const dataGrid = ref({
  parms: DEFAULT_PARMS(),
  data: [],
  pagination: {},
  loading: false,
  orderBy: { prop: 'tcsj', order: 'descending' },
  multipleSelection: [],
  sortChange: function (column) {
    dataGrid.value.orderBy.prop = column.prop
    dataGrid.value.orderBy.order = column.order
    bindTable()
  },
  selectionChange: function (selection) {
    dataGrid.value.multipleSelection = selection.map((item) => item.id)
  }
})

const bindTable = async (pageNo, pageSize) => {
  loadList({
    url: '/api/v2/sys/xuqiu/pagelist',
    pageNo: pageNo || 1,
    pageSize: pageSize || 100,
    dataGrid: dataGrid.value,
    loadSuccess: function () {
      dataGrid.value.multipleSelection = []
    }
  })
}

// 序号跨页连续
const indexMethod = (index) => {
  const p = dataGrid.value.pagination || {}
  const pageNo = Number(p.pageNo || p.page || p.current || 1)
  const pageSize = Number(p.pageSize || p.size || 100)
  return (pageNo - 1) * pageSize + index + 1
}

// 状态标签配色
const statusType = (val) => {
  const map = { 0: 'info', 1: 'warning', 2: 'primary', 3: 'success' }
  return map[Number(val)] || 'info'
}

// 当前行（详情 / 修改弹窗共用）
const row = ref({})

// 外部传入的定位条件（菜单等），重置搜索时需要保留
const baseParms = ref({})

// 重置筛选（查看全部）：只清搜索项，保留外部传入的菜单定位条件
const resetSearch = () => {
  dataGrid.value.parms = { ...DEFAULT_PARMS(), ...baseParms.value }
  bindTable()
}

const openEdit = ref(false)
const openDetail = ref(false)

// 分配
const toFenPei = async (row) => {
  ElMessageBox.prompt('请输入分配给谁', '', {
    confirmButtonText: '提交',
    cancelButtonText: '取消',
    inputValue: row.jjr
  })
    .then(({ value }) => {
      actionPost({
        url: '/api/v2/sys/xuqiu/fenpei',
        data: { id: row.id, jjr: value }
      }).then((res) => {
        if (res.code === 200) {
          successPrompt(res.message)
          bindTable()
        } else {
          warningPrompt(res.message)
        }
      })
    })
    .catch((error) => {
      errorPrompt(error)
    })
}

// 开始（只提交变更字段，避免把整个 row 回传）
const toKaiShi = async (row) => {
  actionPatch({
    url: '/api/v2/sys/xuqiu',
    data: { id: row.id, lx: row.lx ? row.lx.value : row.lx, jjzt: 2 }
  }).then((res) => {
    if (res.code === 200) {
      successPrompt(res.message)
      bindTable()
    } else {
      warningPrompt(res.message)
    }
  })
}

// 解决
const toJieJue = async (row) => {
  ElMessageBox.prompt('请输入解决人', '', {
    confirmButtonText: '提交',
    cancelButtonText: '取消',
    inputValue: row.jjr
  })
    .then(({ value }) => {
      actionPost({
        url: '/api/v2/sys/xuqiu/jiejue',
        data: {
          id: row.id,
          jjr: value,
          jjsj: getDate('YYYY', 'MM', 'DD', 'HH', 'mm')
        }
      }).then((res) => {
        if (res.code === 200) {
          successPrompt(res.message)
          bindTable()
        } else {
          warningPrompt(res.message)
        }
      })
    })
    .catch((error) => {
      errorPrompt(error)
    })
}

// 删除
const remove = async () => {
  submitDataGridAction({
    url: '/api/v2/sys/xuqiu',
    dataGrid: dataGrid.value,
    confirmTitle: '确定要删除吗?',
    method: 'delete',
    callback: function () {
      bindTable()
    }
  })
}

let lastKey = ''
watch(
  () => props.indRow,
  (row) => {
    if (!row) {
      // 无外部条件时也要兜底加载一次
      if (!lastKey) {
        lastKey = '{}'
        bindTable()
      }
      return
    }

    const key = JSON.stringify(row)
    if (key === lastKey) return // ✅ 内容没变就截断递归
    lastKey = key

    // ✅ 断开引用：改成拷贝，别把 props 对象直接塞进去
    baseParms.value = JSON.parse(JSON.stringify(row))
    dataGrid.value.parms = { ...DEFAULT_PARMS(), ...baseParms.value }
    bindTable()
  },
  { deep: true, immediate: true }
)
</script>

<style lang="less" scoped>
.list-page {
  padding: 0;
}

/* 头部：搜索区 + 按钮区（撑开 el-header 默认高度） */
.list-head {
  height: auto;
  padding: 0;
}

.list-body {
  min-height: 0;
}

.search-box {
  display: flex;
  align-items: center;

  .w220 {
    width: 220px;
  }

  .w150 {
    width: 150px;
  }
}

.button-box {
  display: flex;
  align-items: center;
}

.total-tip {
  margin-left: auto;
  font-size: 13px;
  color: var(--el-text-color-secondary);
}

/* 表格 */
:deep(.el-table) {
  .link-title {
    color: var(--el-color-success);
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }

}
</style>
